import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

export const Functionality = React.createContext()

export const API_BASE = 'https://blaketechnologiessite.onrender.com'
const userAxios = axios.create()
userAxios.interceptors.request.use(config => {
    const token = localStorage.getItem("token")
    config.headers.Authorization = `Bearer ${token}`
    return config
})

export default function ContextProvider(props) {
    //-----AuthForm-----
    const initState = {
        user: {},
        token: localStorage.getItem("token") || "",
    }
    const [userState, setUserState] = useState(initState)
    const [sessionReady, setSessionReady] = useState(!initState.token)
    useEffect(() => {
        if (!userState.token) { setSessionReady(true); return; }
        let active = true;
        setSessionReady(false);
        userAxios.get(`${API_BASE}/api/account`).then(({ data }) => {
            if (active) { setUserState(previous => ({ ...previous, user: data.user })); setSessionReady(true); }
        }).catch(() => {
            if (active) {
                localStorage.removeItem('token'); localStorage.removeItem('user');
                setUserState({ user: {}, token: '' }); setSessionReady(true);
            }
        });
        return () => { active = false; };
    }, [userState.token]);
    const [err, setErr] = useState("")
    const initAuth = { email: "", password: "" }
    const [auth, setAuth] = useState(initAuth)
    const navigate = useNavigate(); // Initialize the useNavigate hook

    function handleChangeAuth(e) {
        const { name, value } = e.target
        setAuth(prev => ({
            ...prev,
            [name]: value
        }))
    }
    function handleAuthSubmit(e) {
        e.preventDefault();
        login(auth);
        setAuth(initAuth)
    }

    async function handleRegister(formData) {
        setErr('');
        try {
            await axios.post(`${API_BASE}/auth/signup`, formData);
            navigate('/verify-email');
        } catch (error) {
            setErr(error.response?.data?.errMsg || 'Unable to register. Please try again.');
        }
    }

    function login(credentials) {
        setErr('');
        axios.post(`${API_BASE}/auth/login`, credentials)
            .then(res => {
                const { user, token } = res.data
                localStorage.setItem("token", token)
                localStorage.setItem("user", JSON.stringify(user))
                setUserState(prev => ({
                    ...prev,
                    user,
                    token
                }))
                navigate(user.isEmployee ? '/business-list' : '/portal')
            })
            .catch(err => setErr(err.response?.data?.errMsg || 'Unable to reach the server. Please try again.'))
    }
    function logout() {
        const leaving = new Event('blog-before-logout', { cancelable: true });
        if (!window.dispatchEvent(leaving)) return;
        localStorage.removeItem("token")
        localStorage.removeItem("user")
        setUserState({
            user: {},
            token: "",
        });
        setBusinesses([]); setBlogs({ blogs: [] });
        navigate('/login')
    }
    //-----Employee Portal-----
    const [businesses, setBusinesses] = useState([]);
    async function getAllBusinesses(e) {
        try {
            const res = await userAxios.get(`${API_BASE}/api/business`)
            setBusinesses(prev => ({
                ...prev,
                businesses: res.data
            }))
        } catch (err) {
            console.log(err.response.data)
        }
    }
    // async function addNote(id, note){
    //     try{
    //         const res = await userAxios.put(`${API_BASE}/api/business${id}/note`, note)
    //         const updatedBusiness = res.data;
    //         setBusinesses((prev) => ({
    //         ...prev,
    //         businesses: updatedBusiness
    //         }))
    //     }catch(err){
    //         console.log(err.response.data)
    //     }

    // }

    function handleDeleteBusiness(id) {
        return deleteBusiness(id)
    }
    async function deleteBusiness(id) {
        await userAxios.delete(`${API_BASE}/api/business/${id}`)
        setBusinesses(prev => ({
            ...prev,
            businesses: (prev.businesses || []).filter(item => item._id !== id)
        }))
    }
    function handleBusDelete(id) {
        return deleteBusiness(id)
    }
    const [viewBusinessList, setViewBusinessList] = useState(false)
    async function editBusiness(id, updates) {
        const res = await userAxios.put(`${API_BASE}/api/business/${id}`, updates)
        setBusinesses(prev => ({
            ...prev,
            businesses: (prev.businesses || []).map(item => item._id === id ? res.data : item)
        }))
    }

    // Employee blog management: server enforces current account permissions.
    const [blogs, setBlogs] = useState({ blogs: [] });
    async function getAllBlogs() {
        const { data } = await userAxios.get(`${API_BASE}/api/blog`);
        setBlogs({ blogs: data });
        return data;
    }
    async function getSingleBlogDetail(id) {
        const { data } = await userAxios.get(`${API_BASE}/api/blog/${id}`);
        return data;
    }
    async function saveBlog(id, input) {
        const url = `${API_BASE}/api/blog`;
        const { data } = id ? await userAxios.put(`${url}/${id}`, input) : await userAxios.post(url, input);
        setBlogs(prev => ({ blogs: [data, ...(prev.blogs || []).filter(post => post._id !== data._id)] }));
        return data;
    }
    async function deleteBlog(id) {
        await userAxios.delete(`${API_BASE}/api/blog/${id}`);
        setBlogs(prev => ({ blogs: (prev.blogs || []).filter(post => post._id !== id) }));
    }

    const [toggleStyle, setToggleStyle] = useState(false)
    //-----------------------
    //-----Navbar-----
    const [hamClicked, setHamClicked] = useState(false)

    const homeClick = () => {
        navigate('/')
    }
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    const [showButton, setShowButton] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            window.scrollY > 25 ? setShowButton(true) : setShowButton(false);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const [contactClicked, setContactClicked] = useState(false)

    //----------------

    //-----Home-----
    const [slideNum, setSlideNum] = useState(0);
    const [showForm, setShowForm] = useState(false)

    //--------------

    //-----Contact-----
    const initBusInputs = {
        name: "",
        email: "",
        phoneNumber: "",
        date: "",
        message: "",
        referralCode: "",
        note: "New Business Inquiry Received from Contact Form"
    }
    const [busInputs, setBusInputs] = useState(initBusInputs)
    function handleBusChange(e) {
        const { name, value } = e.target
        setBusInputs(prev => ({
            ...prev,
            [name]: value
        }))
    }
    async function handleBusSubmit() {
        const result = await addBusiness(busInputs);
        setBusInputs(initBusInputs);
        return result;
    }
    async function addBusiness(newBusiness) {
        const res = await axios.post(`${API_BASE}/business`, { data: newBusiness });
        return res.data;
    }
    return (
        <Functionality.Provider
            value={{
                ...userState,
                sessionReady,
                err,
                auth, setAuth,
                handleChangeAuth,
                handleAuthSubmit,
                handleRegister,
                logout,
                viewBusinessList, setViewBusinessList,
                getAllBusinesses,
                editBusiness,
                deleteBusiness,
                handleBusDelete,
                handleDeleteBusiness,
                businesses, setBusinesses,
                addBusiness,
                handleBusChange,
                handleBusSubmit,
                toggleStyle, setToggleStyle,
                hamClicked, setHamClicked,
                contactClicked, setContactClicked,
                scrollToTop,
                showButton, setShowButton,
                homeClick,
                showForm, setShowForm,
                slideNum, setSlideNum,
                busInputs, setBusInputs,
                saveBlog, deleteBlog,
                blogs, setBlogs,
                getAllBlogs,
                getSingleBlogDetail
            }}
        >
            {props.children}
        </Functionality.Provider>
    )
}
